import React, { ReactNode, useCallback } from 'react';
import cx from 'clsx';
import Upload from 'antd/es/upload';
import { UploadChangeParam, UploadProps } from 'antd/lib/upload';
import style from './style.module.css';
import { IconUploadImage } from '@/assets/editor';

interface AvatarUploadProps extends UploadProps {
  src?: string;
  emptyClassName?: string;
  showImgAfterSuccess?: boolean;
  placeholder?: ReactNode;
  onSuccess?: (data: any) => void;
}

export const ImageUpload = ({
  src,
  onSuccess,
  placeholder,
  className,
  emptyClassName,
  ...rest
}: AvatarUploadProps) => {
  const handleChange = useCallback(
    (info: UploadChangeParam) => {
      if (info.file.status === 'uploading') {
        return;
      }

      if (info.file.status === 'done') {
        const logo_url = info.file.response?.data?.logo_url;
        console.log(info.file.response?.data, logo_url);
        onSuccess && onSuccess(info);
      }
    },
    [onSuccess],
  );

  return (
    <Upload
      accept="image/*"
      listType="picture-card"
      className={cx(style.uploader, className)}
      showUploadList={false}
      onChange={handleChange}
      {...rest}>
      {placeholder ? placeholder : <IconUploadImage />}
    </Upload>
  );
};
